import { useNavigate, useLocation } from 'react-router-dom'
import { ADD_VEHICLE_ROUTE, CONNECT_VEHICLES_ROUTE, VEHICLE_INTEGRATION_ROUTE } from '../consts'
import { useCallback } from 'react'

interface UseRouting {
  navigateToVehicleIntegrationMainPage: () => void
  navigateToAddVehiclePage: () => void
  navigateToConnectVehiclesPage: () => void
}

/**
 * Routing hook for easier navigation in vehicle intergration pages
 */
export const useRouting = (): UseRouting => {
  const navigate = useNavigate()
  const location = useLocation()
  const splittedPath = location.pathname.split(VEHICLE_INTEGRATION_ROUTE)
  const defaultRoute = splittedPath[0] + VEHICLE_INTEGRATION_ROUTE + splittedPath[1] + VEHICLE_INTEGRATION_ROUTE

  const navigateToVehicleIntegrationMainPage = useCallback((): void => {
    navigate(defaultRoute)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultRoute])

  const navigateToAddVehiclePage = useCallback((): void => {
    navigate(`${defaultRoute}/${ADD_VEHICLE_ROUTE}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultRoute])

  const navigateToConnectVehiclesPage = useCallback((): void => {
    navigate(`${defaultRoute}/${CONNECT_VEHICLES_ROUTE}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultRoute])

  return {
    navigateToVehicleIntegrationMainPage,
    navigateToAddVehiclePage,
    navigateToConnectVehiclesPage,
  }
}
